// 认证相关工具函数

// 存储token到localStorage
export const setToken = (token) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.setItem('token', token)
  }
}

// 从localStorage获取token
export const getToken = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem('token')
  }
  return null
}

// 存储用户信息到localStorage
export const setUserInfo = (userInfo) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  }
}

// 从localStorage获取用户信息
export const getUserInfo = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const userInfoStr = localStorage.getItem('userInfo')
    return userInfoStr ? JSON.parse(userInfoStr) : null
  }
  return null
}

// 清除localStorage中的token和用户信息
export const removeToken = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
}

// 判断是否已登录
export const isAuthenticated = () => {
  const token = getToken()
  return !!token
}

// 检查用户是否具有指定的按钮权限
export const hasPermission = (permission) => {
  if (!permission) return false
  
  const userInfo = getUserInfo()
  if (!userInfo || !userInfo.menu_list) return false
  
  // 递归检查菜单树中的按钮权限
  const checkPermission = (menus) => {
    for (const menu of menus) {
      // 检查当前菜单是否是按钮权限且权限标识匹配
      if (menu.type === 2 && menu.perms === permission) {
        return true
      }
      // 递归检查子菜单
      if (menu.children && menu.children.length > 0) {
        if (checkPermission(menu.children)) {
          return true
        }
      }
    }
    return false
  }
  
  return checkPermission(userInfo.menu_list)
}

// 检查用户是否具有菜单权限
export const hasMenuPermission = (menuPerms) => {
  if (!menuPerms) return false
  
  const userInfo = getUserInfo()
  if (!userInfo || !userInfo.menu_list) return false
  
  // 递归检查菜单树中的菜单权限
  const checkMenuPermission = (menus) => {
    for (const menu of menus) {
      // 检查当前菜单是否是菜单类型且权限标识匹配
      if ((menu.type === 0 || menu.type === 1) && menu.perms === menuPerms) {
        return true
      }
      // 递归检查子菜单
      if (menu.children && menu.children.length > 0) {
        if (checkMenuPermission(menu.children)) {
          return true
        }
      }
    }
    return false
  }
  
  return checkMenuPermission(userInfo.menu_list)
}